import $http from '@/util/httpRequest.js'
import $common from '@/util/common.js'
import Vue from 'vue';
let V = new Vue();
import $store from '@/store/index.js'

export default{
	// 获取用户信息
	getUserInfo: function(){
		return  new Promise(function(resolve, reject){
			$http({
				url: $store.state.httpUrl+'/common/getUserInfo',
				method: 'GET',
				params:{}
			}).then((res) =>{
				let _user = res.data.data;
				let _token = _user.token;
				$common.setItem('ATOKEN',_token);
				$common.setItem('user',_user);
				resolve(1);
			}).catch((res) => {
				V.$notify.error({
				  title: 'ERROR',
				  message: 'Request failed, please try again later!'
				});
			})
		});
	},
}